import { jsx as _jsx } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { getActivities, getDatesForPeriod } from "../../custom_api/api";
import { emptyOpt, makeOpt } from "../../custom_utils/option";
import { ActivityCluster } from "./activity_cluster";
export class ActivityClusterBlock extends React.Component {
    componentDidMount() {
        getActivities({
            cluster: emptyOpt(),
            activity: makeOpt((q)=>q.Where((q)=>{
                    let exp = q.Id.Equals(0);
                    this.props.activitySummariesIds.forEach((id)=>exp = exp.Or(q.Id.Equals(id)));
                    return exp;
                })),
            edition: emptyOpt(),
            location: emptyOpt(),
            region: emptyOpt(),
            event: makeOpt((q)=>q.Where((e)=>{
                    let period = getDatesForPeriod("komend-halfjaar");
                    return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()));
                }))
        }).then((res)=>{
            if (res != "error" && res !== "loading") {
                this.setState((s)=>({
                        ...s,
                        activitySummaries: res
                    }));
            } else {
                console.log(res);
            }
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(ActivityCluster, {
            activitySummaries: this.state.activitySummaries != "error" && this.state.activitySummaries != "loading" ? this.state.activitySummaries : List(),
            title: this.props.title,
            description: this.props.description,
            slug: "abc"
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activitySummaries: "loading"
        };
    }
}
{}